const SectionHeader = ({ number, title, description }) => {
  return (
    <div className="section-heading">
      <div className="section-number">{number}</div>

      <div>
        <h2>{title}</h2>
        <p>{description}</p>
      </div>
    </div>
  );
};
export default SectionHeader;